let Newsletter_bg = document.querySelector('.newsletter__sub');
let sib = document.querySelector('.sib-form');
let cross_exit = document.querySelector('.cross-newsletter');

/*
  window.onload = function(){
    setTimeout(function(){
      sib.style.display ="block";
    }, 20000)
  }






Newsletter_bg.addEventListener('click', function(){
        sib.style.display ="block";
        console.log('OUI');
})
cross_exit.addEventListener('click', function() {
  sib.style.display ="none";
})

*/

